/* Khayest reusable News section — tab filtering + per-panel carousel.
   <khayest-news>: [data-news-tab] controls the matching [data-news-panel];
   each panel holds a scroll-snap [data-news-track] driven by prev/next arrows. */
if (!customElements.get('khayest-news')) {
  customElements.define(
    'khayest-news',
    class KhayestNews extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-news-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-news-panel]'));
        this.viewports = Array.from(this.querySelectorAll('.khayest-news__viewport'));
        this.viewports.forEach((vp) => this.initCarousel(vp));

        if (this.tabs.length) {
          this.addEventListener('click', (e) => {
            const tab = e.target.closest('[data-news-tab]');
            if (tab && this.contains(tab)) {
              e.preventDefault();
              this.activate(tab);
            }
          });
          this.addEventListener('keydown', (e) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
            const current = document.activeElement;
            if (!current || !current.matches('[data-news-tab]')) return;
            e.preventDefault();
            const i = this.tabs.indexOf(current);
            let next = i;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = this.tabs.length - 1;
            this.activate(this.tabs[next]);
            this.tabs[next].focus();
          });
        }
      }

      activate(tab) {
        const targetId = tab.getAttribute('aria-controls');
        this.tabs.forEach((t) => {
          const selected = t === tab;
          t.classList.toggle('is-active', selected);
          t.setAttribute('aria-selected', selected ? 'true' : 'false');
          t.setAttribute('tabindex', selected ? '0' : '-1');
        });
        this.panels.forEach((p) => {
          const show = p.id === targetId;
          p.classList.toggle('is-active', show);
          p.toggleAttribute('hidden', !show);
          // a hidden panel's track had no measurable width — refresh arrows once shown
          if (show) {
            const vp = p.querySelector('.khayest-news__viewport');
            if (vp && vp._updateArrows) requestAnimationFrame(vp._updateArrows);
          }
        });
      }

      initCarousel(vp) {
        const track = vp.querySelector('[data-news-track]');
        const prev = vp.querySelector('[data-news-prev]');
        const next = vp.querySelector('[data-news-next]');
        if (!track) return;

        const step = () => Math.max(track.clientWidth * 0.85, 240);
        const update = () => {
          const max = track.scrollWidth - track.clientWidth - 1;
          const scrollable = max > 0;
          if (prev) prev.toggleAttribute('disabled', !scrollable || track.scrollLeft <= 0);
          if (next) next.toggleAttribute('disabled', !scrollable || track.scrollLeft >= max);
        };
        vp._updateArrows = update;

        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', () => update(), { passive: true });
        window.addEventListener('resize', update);
        requestAnimationFrame(update);
      }
    }
  );
}
